function secondsToTimer(seconds) {
  var hours = parseInt(seconds / 3600) % 24;
  var minutes = parseInt(seconds / 60) % 60;
  var result = `${hours}h ${minutes}m`;

  return result;
}

function minutesToTimer(_minutes) {
  var minutes = _minutes % 60;
  var hours = parseInt(_minutes / 60);
  var result = `${hours}h ${minutes}m`;

  return result;
}

export { secondsToTimer, minutesToTimer };
